import api from './api.jsx';

const certificateAPI = {
  // Get certificate by token (public endpoint)
  getCertificate: async (token) => {
    try {
      const response = await api.get(`/api/certificates/${token}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching certificate:', error);
      throw error;
    }
  },

  // Download certificate as HTML (public endpoint)
  downloadCertificate: async (token) => {
    try {
      const response = await api.get(`/api/certificates/${token}/download`, {
        responseType: 'blob'
      });
      
      // Create blob URL and trigger download
      const blob = new Blob([response.data], { type: 'text/html' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `certificate_${token}.html`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      return { success: true };
    } catch (error) {
      console.error('Error downloading certificate:', error);
      throw error;
    }
  },

  // Get user's virtual prizes (admin endpoint)
  getUserPrizes: async (email) => {
    try {
      const response = await api.get(`/api/certificates/admin/user/${email}/prizes`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user prizes:', error);
      throw error;
    }
  },

  // Get all certificates (admin only)
  getAllCertificates: async () => {
    try {
      const response = await api.get(`/api/certificates/admin/all`);
      return response.data;
    } catch (error) {
      console.error('Error fetching certificates:', error);
      throw error;
    }
  },

  // Get all virtual prizes (admin only)
  getAllPrizes: async () => {
    try {
      const response = await api.get(`/api/certificates/admin/prizes`);
      return response.data;
    } catch (error) {
      console.error('Error fetching virtual prizes:', error);
      throw error;
    }
  },

  // Award virtual prizes (admin only)
  awardPrizes: async (sessionId) => {
    try {
      const response = await api.post(`/api/certificates/award-prizes`, {
        sessionId
      });
      return response.data;
    } catch (error) {
      console.error('Error awarding prizes:', error);
      throw error;
    }
  },

  // Get certificate statistics (admin only)
  getCertificateStats: async () => {
    try {
      const response = await api.get(`/api/certificates/admin/stats`);
      return response.data;
    } catch (error) {
      console.error('Error fetching certificate stats:', error);
      throw error;
    }
  },

  // Generate test certificate (admin only)
  generateTestCertificate: async (testData) => {
    try {
      const response = await api.post(`/api/certificates/test`, testData);
      return response.data;
    } catch (error) {
      console.error('Error generating test certificate:', error);
      throw error;
    }
  },

  // Generate certificate preview HTML (admin only)
  generateCertificatePreview: async (testData) => {
    try {
      const response = await api.post(`/api/certificates/preview`, testData);
      return response.data;
    } catch (error) {
      console.error('Error generating certificate preview:', error);
      throw error;
    }
  }
};

export default certificateAPI;
